import React from "react";
import QuestionEditChoice from "../QuestionEditChoice";
import {findNextAvailableQidForSelect} from "../../../../../../utils/SurveyUtils";
import {Draggable, Droppable} from "react-beautiful-dnd";
import {isSurveyEditRestrictedSelector} from "../../../../../../slices/surveyEditorSlice";
import {useSelector} from "react-redux";

function MatrixRowsChoiceEdit(props) {
    const surveyEditRestricted = useSelector(isSurveyEditRestrictedSelector);

    const handleAddNewRow = (choices) => {
        let options;
        if (typeof choices[0].options !== "undefined") {
            // For new choices (selects), the options must have null IDs (to be persisted)
            let optionsWithoutIds = choices[0].options.map((option) => {option.options_id = null; return option;});
            options = JSON.parse(JSON.stringify(optionsWithoutIds));
        }
        const {questionData} = props;
        let newChoice = {
            "label": "",
            "id": findNextAvailableQidForSelect(questionData.selects, questionData.id),
            "select_id": null,
            "options": options
        };
        choices.push(newChoice);
    };

    const handleRemove = (choices, idx) => {
        choices.splice(idx, 1);
    };

    const buildChoicesList = () => {
        const {questionData, questionValid, errorMessages, handleRemoveChoice, handleQuestionChoiceTextChange} = props;
        let htmlChoicesList;

        if(!surveyEditRestricted) {
            htmlChoicesList = questionData.selects.map((choice, index) => {
                const idChoice = "selectId_" + choice.id + "_" + index;
                return (
                    <Draggable class="draggable" draggableId={index + "_draggables_selects"} index={index}
                               key={"draggable_choice_row_item_key_" + index}>
                        {(provided) => (
                            <div ref={provided.innerRef}
                                 {...provided.draggableProps}
                                 {...provided.dragHandleProps} key={choice.id}>

                                <QuestionEditChoice
                                    idChoice={idChoice}
                                    key={idChoice}
                                    choiceText={choice.label}
                                    choiceValue={choice.id}
                                    onChange={(event) => {
                                        handleQuestionChoiceTextChange(event, index, true)
                                    }}
                                    handleRemoveChoice={(event) => {
                                        handleRemoveChoice(event, index, handleRemove)
                                    }}
                                    questionValid={questionValid}
                                    errorMessage={errorMessages[index]}
                                    showRemoveButton={questionData.selects.length > 2}
                                    isChoiceMatrixRow={true}
                                    maxLength={512}
                                />
                            </div>
                        )}
                    </Draggable>
                );
            });
        } else {
            htmlChoicesList = questionData.selects.map((choice, index) => {
                const idChoice = "selectId_" + choice.id + "_" + index;
                return (
                    <QuestionEditChoice
                        idChoice={idChoice}
                        key={idChoice}
                        choiceText={choice.label}
                        choiceValue={choice.id}
                        onChange={(event) => {
                            handleQuestionChoiceTextChange(event, index, true)
                        }}
                        handleRemoveChoice={(event) => {
                            handleRemoveChoice(event, index, handleRemove)
                        }}
                        questionValid={questionValid}
                        errorMessage={errorMessages[index]}
                        showRemoveButton={questionData.selects.length > 2}
                        isChoiceMatrixRow={true}
                        maxLength={512}
                    />
                );
            });
        }

        return htmlChoicesList;
    };

    const htmlRowList = buildChoicesList();
    return (
        <React.Fragment>
            <div className="questionaire__builder__question__subtitle questionaire__builder__col1">
                <span>ROWS</span>
                {/*<a className="questionaire__builder__question__subtitle__action questionaire__builder__question__subtitle__action--addbulk"*/}
                   {/*href="#" onClick={(event) => {event.preventDefault();}}>Add answers in bulk</a>*/}
            </div>
            <div className="questionaire__builder__question__inputs">
                <div className="questionaire__builder__col1">
                    <Droppable droppableId="droppable_select" class="droppable_select" type={props.questionData.id}>
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {htmlRowList}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>

                </div>
            </div>
            <div className="questionaire__builder__question__subtitle questionaire__builder__col1">
                <a className="questionaire__builder__question__subtitle__action"
                   href="#" onClick={(event) => {event.preventDefault();props.handleAddNewChoice(event, handleAddNewRow);}}>+ Add new answer</a>
            </div>
        </React.Fragment>
    );
}

export default MatrixRowsChoiceEdit;